// This file is auto-generated by @hey-api/openapi-ts
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var createSseClient = function (_a) {
    var onRequest = _a.onRequest, onSseError = _a.onSseError, onSseEvent = _a.onSseEvent, responseTransformer = _a.responseTransformer, responseValidator = _a.responseValidator, sseDefaultRetryDelay = _a.sseDefaultRetryDelay, sseMaxRetryAttempts = _a.sseMaxRetryAttempts, sseMaxRetryDelay = _a.sseMaxRetryDelay, sseSleepFn = _a.sseSleepFn, url = _a.url, options = __rest(_a, ["onRequest", "onSseError", "onSseEvent", "responseTransformer", "responseValidator", "sseDefaultRetryDelay", "sseMaxRetryAttempts", "sseMaxRetryDelay", "sseSleepFn", "url"]);
    var lastEventId;
    var sleep = sseSleepFn !== null && sseSleepFn !== void 0 ? sseSleepFn : (function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); });
    var createStream = function () {
        var _a, _b, _c;
        return __asyncGenerator(this, arguments, function () {
            var retryDelay, attempt, signal, _loop_1, state_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        retryDelay = sseDefaultRetryDelay !== null && sseDefaultRetryDelay !== void 0 ? sseDefaultRetryDelay : 3000;
                        attempt = 0;
                        signal = (_a = options.signal) !== null && _a !== void 0 ? _a : new AbortController().signal;
                        _loop_1 = function () {
                            var headers, requestInit, request, _fetch, response, reader_1, buffer, abortHandler, _e, done, value, chunks, chunks_1, chunks_1_1, chunk, lines, dataLines, eventName, lines_1, lines_1_1, line, parsed, data, parsedJson, rawData, e_1_1, error_1, backoff;
                            var e_1, _f, e_2, _g;
                            return __generator(this, function (_h) {
                                switch (_h.label) {
                                    case 0:
                                        if (signal.aborted)
                                            return [2 /*return*/, "break"];
                                        attempt++;
                                        headers = options.headers instanceof Headers
                                            ? options.headers
                                            : new Headers(options.headers);
                                        if (lastEventId !== undefined) {
                                            headers.set("Last-Event-ID", lastEventId);
                                        }
                                        _h.label = 1;
                                    case 1:
                                        _h.trys.push([1, 24, , 26]);
                                        requestInit = __assign(__assign({ redirect: "follow" }, options), { body: options.serializedBody, headers: headers, signal: signal });
                                        request = new Request(url, requestInit);
                                        if (!onRequest) return [3 /*break*/, 3];
                                        return [4 /*yield*/, __await(onRequest(url, requestInit))];
                                    case 2:
                                        request = _h.sent();
                                        _h.label = 3;
                                    case 3:
                                        _fetch = (_b = options.fetch) !== null && _b !== void 0 ? _b : globalThis.fetch;
                                        return [4 /*yield*/, __await(_fetch(request))];
                                    case 4:
                                        response = _h.sent();
                                        if (!response.ok)
                                            throw new Error("SSE failed: ".concat(response.status, " ").concat(response.statusText));
                                        if (!response.body)
                                            throw new Error("No body in SSE response");
                                        reader_1 = response.body
                                            .pipeThrough(new TextDecoderStream())
                                            .getReader();
                                        buffer = "";
                                        abortHandler = function () {
                                            try {
                                                reader_1.cancel();
                                            }
                                            catch (_a) {
                                                // noop
                                            }
                                        };
                                        signal.addEventListener("abort", abortHandler);
                                        _h.label = 5;
                                    case 5:
                                        _h.trys.push([5, , 22, 23]);
                                        _h.label = 6;
                                    case 6:
                                        if (!true) return [3 /*break*/, 21];
                                        return [4 /*yield*/, __await(reader_1.read())];
                                    case 7:
                                        _e = _h.sent(), done = _e.done, value = _e.value;
                                        if (done)
                                            return [3 /*break*/, 21];
                                        buffer += value;
                                        chunks = buffer.split("\n\n");
                                        buffer = (_c = chunks.pop()) !== null && _c !== void 0 ? _c : "";
                                        _h.label = 8;
                                    case 8:
                                        _h.trys.push([8, 18, 19, 20]);
                                        chunks_1 = (e_1 = void 0, __values(chunks)), chunks_1_1 = chunks_1.next();
                                        _h.label = 9;
                                    case 9:
                                        if (!!chunks_1_1.done) return [3 /*break*/, 17];
                                        chunk = chunks_1_1.value;
                                        lines = chunk.split("\n");
                                        dataLines = [];
                                        eventName = void 0;
                                        try {
                                            for (lines_1 = (e_2 = void 0, __values(lines)), lines_1_1 = lines_1.next(); !lines_1_1.done; lines_1_1 = lines_1.next()) {
                                                line = lines_1_1.value;
                                                if (line.startsWith("data:")) {
                                                    dataLines.push(line.replace(/^data:\s*/, ""));
                                                }
                                                else if (line.startsWith("event:")) {
                                                    eventName = line.replace(/^event:\s*/, "");
                                                }
                                                else if (line.startsWith("id:")) {
                                                    lastEventId = line.replace(/^id:\s*/, "");
                                                }
                                                else if (line.startsWith("retry:")) {
                                                    parsed = Number.parseInt(line.replace(/^retry:\s*/, ""), 10);
                                                    if (!Number.isNaN(parsed)) {
                                                        retryDelay = parsed;
                                                    }
                                                }
                                            }
                                        }
                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                        finally {
                                            try {
                                                if (lines_1_1 && !lines_1_1.done && (_g = lines_1.return)) _g.call(lines_1);
                                            }
                                            finally { if (e_2) throw e_2.error; }
                                        }
                                        data = void 0;
                                        parsedJson = false;
                                        if (dataLines.length) {
                                            rawData = dataLines.join("\n");
                                            try {
                                                data = JSON.parse(rawData);
                                                parsedJson = true;
                                            }
                                            catch (_j) {
                                                data = rawData;
                                            }
                                        }
                                        if (!parsedJson) return [3 /*break*/, 13];
                                        if (!responseValidator) return [3 /*break*/, 11];
                                        return [4 /*yield*/, __await(responseValidator(data))];
                                    case 10:
                                        _h.sent();
                                        _h.label = 11;
                                    case 11:
                                        if (!responseTransformer) return [3 /*break*/, 13];
                                        return [4 /*yield*/, __await(responseTransformer(data))];
                                    case 12:
                                        data = _h.sent();
                                        _h.label = 13;
                                    case 13:
                                        onSseEvent === null || onSseEvent === void 0 ? void 0 : onSseEvent({
                                            data: data,
                                            event: eventName,
                                            id: lastEventId,
                                            retry: retryDelay,
                                        });
                                        if (!dataLines.length) return [3 /*break*/, 16];
                                        return [4 /*yield*/, __await(data)];
                                    case 14: return [4 /*yield*/, _h.sent()];
                                    case 15:
                                        _h.sent();
                                        _h.label = 16;
                                    case 16:
                                        chunks_1_1 = chunks_1.next();
                                        return [3 /*break*/, 9];
                                    case 17: return [3 /*break*/, 20];
                                    case 18:
                                        e_1_1 = _h.sent();
                                        e_1 = { error: e_1_1 };
                                        return [3 /*break*/, 20];
                                    case 19:
                                        try {
                                            if (chunks_1_1 && !chunks_1_1.done && (_f = chunks_1.return)) _f.call(chunks_1);
                                        }
                                        finally { if (e_1) throw e_1.error; }
                                        return [7 /*endfinally*/];
                                    case 20: return [3 /*break*/, 6];
                                    case 21: return [3 /*break*/, 23];
                                    case 22:
                                        signal.removeEventListener("abort", abortHandler);
                                        reader_1.releaseLock();
                                        return [7 /*endfinally*/];
                                    case 23: return [2 /*return*/, "break"];
                                    case 24:
                                        error_1 = _h.sent();
                                        // connection failed or aborted; retry after delay
                                        onSseError === null || onSseError === void 0 ? void 0 : onSseError(error_1);
                                        if (sseMaxRetryAttempts !== undefined &&
                                            attempt >= sseMaxRetryAttempts) {
                                            return [2 /*return*/, "break"];
                                        }
                                        backoff = Math.min(retryDelay * Math.pow(2, (attempt - 1)), sseMaxRetryDelay !== null && sseMaxRetryDelay !== void 0 ? sseMaxRetryDelay : 30000);
                                        return [4 /*yield*/, __await(sleep(backoff))];
                                    case 25:
                                        _h.sent();
                                        return [3 /*break*/, 26];
                                    case 26: return [2 /*return*/];
                                }
                            });
                        };
                        _d.label = 1;
                    case 1:
                        if (!true) return [3 /*break*/, 3];
                        return [5 /*yield**/, _loop_1()];
                    case 2:
                        state_1 = _d.sent();
                        if (state_1 === "break")
                            return [3 /*break*/, 3];
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var stream = createStream();
    return { stream: stream };
};
